<template>
	<div class="education">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in educationList"
				:key="ind">

				<van-card
					:desc="item.professional||''"
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<span style="font-weight:bold;">{{item.school}}</span> <span class="skin_color">{{item.education}}</span>
					</template>
					<template #num>
						<van-tag plain type="warning" v-if="item.in_clan">族谱展示</van-tag>
					</template>
					<template #price>
						{{item.date_edu?item.date_edu:(item.date_start+' 至 '+item.date_end)}}
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditEducation(item.id)" v-if="!readonly"/>
					<van-button square text="删除" type="danger" @click="onDelEducation(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>
			<div class="empty" v-if="educationList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditEducation" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px' }">
			<van-cell-group > 
				<van-field
					v-model.trim="educationInfo.school"
					label="学校："
					required
					placeholder="请输入学校名称"
					clearable
				></van-field>
				<van-field
					v-model.trim="educationInfo.education"
					label="学历："
					placeholder="请输入或选择"
					clearable
				>
					<template #right-icon>
						<van-icon name="ellipsis" @click="showPicker=true"/>
					</template>
				</van-field>
				<van-field
					v-model.trim="educationInfo.professional"
					label="专业："
					placeholder="请输入专业"
					clearable
				></van-field>
				<van-cell title="时间：" title-class="van-field__label">
					<template #default>{{educationInfo.date_edu?educationInfo.date_edu:(educationInfo.date_start||educationInfo.date_end?(educationInfo.date_start+' 至 '+educationInfo.date_end):'')}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showPopup2EducationTime" :style="{'margin-left':'5px'}">选 / 填</van-button></template>
				</van-cell>
				<van-field
				  v-model.trim="educationInfo.remark"
				  rows="3"
				  autosize
				  label="备注："
				  type="textarea"
				  maxlength="3000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>
				<van-cell
					:value="''"
					title-class="van-cell-title"
				>
					<template #title>
						<span class="custom-title">族谱展示：{{inclansChk?'是':'否'}}</span>
					</template>
					<template #right-icon>
						<van-switch v-model="inclansChk"  @input="onInclansChk"/>
					</template>
				</van-cell>

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditEducation=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveEducation">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>
		</van-popup>

		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="markColumns"
			@cancel="showPicker = false"
			@confirm="onMarkConfirm"
		  />
		</van-popup>

		<van-popup v-model="showEducationTimePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">

				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="5">
						<van-sidebar v-model="sidebarActiveKey">
							<van-sidebar-item title="选择日期" />
							<van-sidebar-item title="手动输入" />
						</van-sidebar>
					</van-col>
					<van-col span="19">
						<van-cell-group > 
							<van-field
								v-model.trim="educationInfo.date_edu"
								label=""
								placeholder="请输入学业时间"
								clearable
							v-if="sidebarActiveKey==1"
							></van-field>

							<van-cell
								title="起始日期："
								is-link
								:value="educationInfo.date_start"
								title-class="van-cell-title"
								v-if="sidebarActiveKey==0"
								@click="showEducationTimePicker=1"
							>
								<template #right-icon>
									<van-icon name="arrow" class="van-cell__right-icon" />
									<van-button type="default" plain hairline size="mini" @click.stop="educationInfo.date_start=''" :style="{'margin-left':'5px'}">置空</van-button>
								</template>
							</van-cell>
							<van-cell
								title="结束日期："
								is-link
								:value="educationInfo.date_end"
								title-class="van-cell-title"
								v-if="sidebarActiveKey==0"
								@click="showEducationTimePicker=2"
							>
								<template #right-icon>
									<van-icon name="arrow" class="van-cell__right-icon" />
									<van-button type="default" plain hairline size="mini" @click.stop="educationInfo.date_end=''" :style="{'margin-left':'5px'}">置空</van-button>
								</template>
							</van-cell> 
						</van-cell-group > 
					</van-col>
				</van-row> 
				<van-row  :style="{'margin-bottom':'10px'}" v-if="sidebarActiveKey==0&&showEducationTimePicker>0">
					<van-col span="24">
						<van-cell-group>
							<van-datetime-picker
								type="date"
								:title="showEducationTimePicker==1?'起始日期':'结束日期'"
								:min-date="new Date(1900, 0, 1)"
								:max-date="new Date()"
								
								@confirm="onConfirmEducationTime"
								@cancel="showEducationTimePicker=0"
							/>
						</van-cell-group > 
					</van-col>
				</van-row> 
				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="22">
						<van-button type="primary" block  @click="showEducationTimePopup=false" :disabled="sidebarActiveKey==0&&showEducationTimePicker>0">确定</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 
			
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddEducation" v-if="!readonly"/>

	</div>
</template>

<script>
import {Card, SwipeCell, Sidebar, SidebarItem, DatetimePicker } from "vant";

export default {
	name: "education",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker
	},
	props:{
		p_id:Number,
		readonly:Boolean
	},
	data() {
		return {
			title: "教育信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),

			educationList:[],
			educationInfoObj:{},
			showEditEducation:false,
			educationInfo:{},
			showPicker:false,
			markColumns:['初中及以下','中专','高中','大专','本科','研究生','博士'],
			showEducationTimePopup:false,
			sidebarActiveKey:0,
			showEducationTimePicker:0,
			inclansChk:false,
			saveFlag:false
		};
	},
	created() {
		this.getEducationData();
	},
	computed: {
	},
	methods: {
		getEducationData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalEdu" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.educationList = [];
				that.educationInfoObj = {};
				let edus = response.data.datas;
				if(edus && edus.length > 0){
					that.educationList = edus;
					for(var i=0,il=edus.length; i<il; i++){
						that.educationInfoObj[edus[i]['id']] = edus[i];
					};
				}
			})
			.catch(error => {});
		},
		onMarkConfirm(val,ind){
			this.educationInfo.education = val;
			this.showPicker = false;
		},
		showPopup2EducationTime(){
			this.showEducationTimePopup = true;
			this.sidebarActiveKey = this.educationInfo.date_edu?1:0;
		},
		onAddEducation(){
			this.educationInfo = {p_id:this.p_id};
			this.showEditEducation = true;
		},
		onEditEducation(id){
			this.educationInfo = this.educationInfoObj[id];
			this.inclansChk = this.educationInfo.in_clan==1;
			this.showEditEducation = true;
		},
		onDelEducation(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalEduDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getEducationData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveEducation(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.educationInfo['school']){
				this.$toast.fail("请输入学校名称！");
				return false;
			}
			this.saveFlag = true;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.educationInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalEduSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getEducationData();
					that.showEducationTimePopup = false;
					that.showEditEducation = false;
				}
			})
			.catch(error => {});
		},
		onConfirmEducationTime(val){
			if(this.showEducationTimePicker==1){
				this.educationInfo.date_start = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}else{
				this.educationInfo.date_end = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}
			this.showEducationTimePicker=0;
			this.$forceUpdate();
		},
		onInclansChk(chk){
			this.educationInfo.in_clan = chk?1:0;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/Education.vue